export default "__VITE_ASSET__CmyUOgH7__"